import './App.css';
import domainNameLookup from './utils/domainNameLookup.js';
import DatasetMasterSearch from './components/DatasetMasterSearch.js';
import DatasetCardGrid from './components/DatasetCardGrid.js';
import DatasetCountBar from './components/DatasetCountBar.js';
import NavLinkIcon from './components/NavLinkIcon.js';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
//import DataProvider from './models/DataProvider.js';
import MetadataProvider from './models/MetadataProvider.js';
import React from 'react';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      metadata: [],
      metadataLoaded: false,
      searchActive: false,
      searchText: '',
      searchPlaceholder: 'Search Datasets ...',
      activeDomain: '',
      activeNavKey: ''
    };
    this.domains = [
      'electricity', 'energy', 'non_renewable_energy',
      'renewable_energy', 'transportation', 'energy_efficiency'
    ];
    this.metadataProvider = new MetadataProvider('metadata');
    //this.dataProvider = new DataProvider('non_renewable_energy', 'percentage_of_states_energy_from_petroleum.csv');
    this.handleDataLoad = this.handleDataLoad.bind(this);
    this.handleSearchOnChange = this.handleSearchOnChange.bind(this);
    this.handleClearSearch = this.handleClearSearch.bind(this);
    this.handleNavSelect = this.handleNavSelect.bind(this);
  }

  componentDidMount() {
    this.metadataProvider.fetchMetadata(this.handleDataLoad);
    //this.dataProvider.fetchData(console.log);
  }

  handleDataLoad(responseObject) {
    this.setState({
      metadata: responseObject.metadata,
      metadataLoaded: true
    })
  }


  handleSearchOnChange(event) {
    this.setState({
      searchText: event.target.value,
      searchActive: event.target.value !== ''
    })
  }

  handleClearSearch() {
    this.setState({
      searchText: '',
      searchActive: false
    });
  }

  handleNavSelect(eventKey) {
    if (eventKey === this.state.activeNavKey) {
      this.setState({
        searchPlaceholder: 'Search Datasets ...',
        searchText: '',
        searchActive: false,
        activeDomain: '',
        activeNavKey: ''
      });
    } else {
      this.setState({
        searchPlaceholder: `Search ${domainNameLookup[this.domains[Number(eventKey)]]} ...`,
        searchText: '',
        searchActive: false,
        activeDomain: this.domains[Number(eventKey)],
        activeNavKey: eventKey
      });
    }
  }

  render() {
    const { searchText, metadata, searchPlaceholder, activeDomain, activeNavKey } = this.state;
   
    const filteredMetadata = metadata.filter(
      metaObj => (
        (metaObj.description.includes(searchText.toLowerCase()) ||
        metaObj.datasetName.toLowerCase().includes(searchText.toLowerCase())) &&
        (activeDomain === '' || metaObj.domain === activeDomain)
      )
    );
    return (
      <div className="App">
        <Container fluid>
          <Row style={{
            backgroundImage: 'url(/searchbar_background_image_lg.jpg)', 
            backgroundSize: 'cover', backgroundRepeat: 'no-repeat', paddingTop: '1.5em',
            backgroundPosition: 'center top'
          }}>
            <h4 style={{color: '#F2AE00', textAlign: 'center', fontSize: '1.5em'}}>Welcome to the Hawai&#x02BB;i State Energy Office's Open Data Portal!</h4>
            <DatasetMasterSearch
              onChange={this.handleSearchOnChange}
              clearSearch={this.handleClearSearch}
              metadata={metadata}
              searchText={searchText}
              searchPlaceholder={searchPlaceholder}
            />
          </Row>
          <Row style={{paddingRight: '0px'}}>
            <Nav variant="pills" justify onSelect={this.handleNavSelect} activeKey={activeNavKey}>
              {this.domains.map((domain, idx) => (
                <Nav.Item key={idx}>
                  <Nav.Link eventKey={`${idx}`} className="nav-link-icon">
                    <NavLinkIcon domain={domain} />
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Row>
          <DatasetCountBar datasetCount={filteredMetadata.length} metadata={metadata} />
          <DatasetCardGrid metadata={filteredMetadata} activeDomain={activeDomain}/>
        </Container>
      </div>

    );
  }

}

export default App;
